import React, { FunctionComponent } from "react";
import { useNavigate } from "react-router-dom";
import "./style.scss";

const TopMenu: FunctionComponent = () => {
    const navigate = useNavigate();

    const goTo = (id: string) => {
        navigate("/");
        setTimeout(() => {
            const el = document.getElementById(id);
            if (el)
                el.scrollIntoView({behavior: 'smooth'});
        }, 100);    
    }

    return <div className="TopMenu">
        <div className="menuItem" onClick={() => goTo("pricign")}>Messengers</div>
        <div className="menuItem" onClick={() => goTo("features")}>Features</div>
        <div className="menuItem" onClick={() => goTo("about")}>About</div>
    </div>
}

export default TopMenu;